import { render, staticRenderFns } from "./DemoDatepickerBirthdayPicker.vue?vue&type=template&id=aae8ef1e&"
import script from "./DemoDatepickerBirthdayPicker.vue?vue&type=script&lang=js&"
export * from "./DemoDatepickerBirthdayPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})
